import { useState } from "react";

/**
 * Suspends the component based on a reactive variable.
 *
 * @param shouldSuspend Whether the component should currently be suspended. Should be a reactive variable.
 */
export function useSuspend(shouldSuspend: boolean): void {
  // A promise that never resolves. Using component-state instead of a global variable,
  // so the promise-listeners can be garbage collected when the component is unmounted.
  const [suspensePromise] = useState(() => new Promise(() => {}));

  if (shouldSuspend) {
    // Throwing a promise will suspend the component. With react 19, the use() hook should be used instead.
    // The component will re-render if shouldSuspend changes, un-suspending the component
    throw suspensePromise;
  }
}
